// extracted by css-extract-rspack-plugin
export default {"linkSecondary":"link-secondary--JIjVMSV5JqgsXubO","linkSecondaryContrast":"link-secondary-contrast--fu2WXy_fH2AR3RtP"};